var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer pl-3 pr-3 fixed-bottom bg-white border-top pt-2 pb-2 shadow-lg small"},[_vm._v(" © "+_vm._s(new Date().getFullYear())+" - "+_vm._s(_vm.username)+" - "+_vm._s(this.perfilColetor)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }